import "material-design-icons-iconfont/dist/material-design-icons.css";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";

export default TiptapVuetifyPlugin;
